import {
  getlinesByStreetId,
  updateLine,
  deleteLine,
  createLine,
} from "../../../api/line/lineRequest";
import { useEntityManagement } from "../../../hooks/useEntityManagement";

export const useLineManagement = (streetId, form) => {
  const lineManagement = useEntityManagement(form, {
    entityName: "ligne",
    api: {
      getEntities: () => getlinesByStreetId(streetId),
      createEntity: (value) => createLine({ ...value, street_id: streetId }),
      updateEntity: updateLine,
      deleteEntity: deleteLine,
    },
  });

  return {
    ...lineManagement,
  };
};
